import axios from 'axios'
import { API_URL, getAuthHeader } from '@/services/api.service.js'
import { logger } from '@/utils/logger'

export const fetchPlannedChanges = async ({ boardId, filters }) => {
  try {
    const encodedFilters = encodeURIComponent(JSON.stringify(filters))
    const ret = await axios.get(
      `${await API_URL()}/plannedChanges/${boardId}?filters=${encodedFilters}`,
      {
        headers: {
          ...(await getAuthHeader())
        }
      }
    )
    if (ret.status === 200) {
      logger.info(ret)
      return ret
    } else throw new Error(ret.statusText)
  } catch (error) {
    logger.info(error.message)
    return null
  }
}
